import React from 'react';
import PropTypes from 'prop-types';

import { getSrcString } from '../helpers/getSrcStrings';

import styles from './HpRespHeroModuleItemOld.scss';

function HpRespHeroModuleItemOld({ item, isVisible, onClick }) {
    const { imageUrl, title, link } = item;

    return (
        <a
            data-tn="hero-item-link"
            href={link}
            className={styles.heroItem}
            style={{ opacity: isVisible ? '1' : '0' }}
            onClick={onClick}
        >
            <div className={styles.imageWrapper}>
                <img
                    className={styles.image}
                    src={getSrcString({ url: imageUrl })}
                    alt={title}
                    data-tn="hero-item-image"
                />
            </div>
            <div
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: title }}
                data-tn="hero-item-title"
            />
        </a>
    );
}

HpRespHeroModuleItemOld.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        link: PropTypes.string,
    }).isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

HpRespHeroModuleItemOld.defaultProps = {
    isVisible: true,
};

export { HpRespHeroModuleItemOld };
